// extracted by mini-css-extract-plugin
module.exports = {"main":"main-25M7O","wide":"wide-3C0cB"};